import isEqual from "lodash/isEqual";
import isPlainObject from "lodash/isPlainObject";
import keys from "lodash/keys";
import pick from "lodash/pick";

export function getChangedData<Result = any>(
  initialData: any = {},
  updatedData: Result,
  options?: { dismissTimeInDates?: boolean; strict?: boolean }
) {
  function isChanged(_old: any, _new: any): any {
    const isObject = isPlainObject(_new) && isPlainObject(_old);
    const isArray = Array.isArray(_new) && Array.isArray(_old);

    if (isArray && _new.length !== _old.length) {
      return true;
    } else if (
      options?.strict &&
      isObject &&
      keys(_old).length !== keys(_new).length
    ) {
      return true;
    } else if (isObject || isArray) {
      const fields = keys(_new);

      return fields.some(field => {
        return isChanged(_old[field], _new[field]);
      });
    } else if (_old instanceof Date && _new instanceof Date) {
      if (options?.dismissTimeInDates) {
        return !(
          _old.getDate() === _new.getDate() &&
          _old.getMonth() === _new.getMonth() &&
          _old.getFullYear() === _new.getFullYear()
        );
      } else {
        return !isEqual(_old, _new);
      }
    } else {
      return !isEqual(_old, _new);
    }
  }
  const changedFields = keys(updatedData).filter(field =>
    isChanged(initialData[field], (updatedData as any)[field])
  );

  return pick(updatedData, changedFields) as Partial<Result>;
}
